export const daysArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
